import { cloneElement, useState } from "react";
import PropTypes from "prop-types";

function FlowController({
  screens,
  initialParams = {},
  initialScreen,
  betweenScreens,
}) {
  const [currentScreen, setCurrentScreen] = useState(initialScreen);
  const [params, setParams] = useState(initialParams);

  const setScreenWithParams = (screenName, paramsToPass) => {
    if (!screenName) {
      return;
    }

    if (betweenScreens) {
      betweenScreens();
    }

    if (paramsToPass) {
      setParams(paramsToPass);
    }
    setCurrentScreen(screenName);
  };

  const CurrentComponent = screens[currentScreen];

  if (typeof CurrentComponent === "function") {
    return <CurrentComponent setScreen={setScreenWithParams} params={params} />;
  }

  return cloneElement(CurrentComponent, {
    setScreen: setScreenWithParams,
    params,
  });
}

FlowController.propTypes = {
  screens: PropTypes.shape({}).isRequired,
  initialParams: PropTypes.shape({}),
  initialScreen: PropTypes.string.isRequired,
  betweenScreens: PropTypes.func,
};

export { FlowController };
